import { TEALIUM_PROD_ACTION } from '@client/analytics/types/types';
import { createAction } from '@reduxjs/toolkit';

export const analyzeBarcodeScan = createAction<{
  barcodeAction: TEALIUM_PROD_ACTION,
  barcode?: string,
  sku?: string,
}>('analyzeBarcodeScan');
